import React from 'react'

import { Alert, Flex, Text } from '@chakra-ui/react'
import { Icon, Spinner, Typography } from '@pnld/components-web'

// Tabelas do censo, na ordem da tela. `table` é a chave da prévia (nome da
// tabela) e `model`, a do relatório do import (nome do model); ambas em
// camelCase, como o cliente HTTP entrega a resposta da API.
export const CENSUS_TABLES = [
  {
    table: 'descricaoEscola',
    model: 'schoolDescription',
    label: 'Descrição da escola',
  },
  { table: 'matriculas', model: 'schoolRegistration', label: 'Matrículas' },
  { table: 'turmas', model: 'schoolClass', label: 'Turmas' },
  { table: 'corpoDocente', model: 'teachingStaff', label: 'Corpo docente' },
  {
    table: 'infraestruturaEscola',
    model: 'schoolInfrastructure',
    label: 'Infraestrutura',
  },
  { table: 'materiais', model: 'materials', label: 'Materiais' },
  {
    table: 'orgaosColegiados',
    model: 'collegiateAgency',
    label: 'Órgãos colegiados',
  },
  {
    table: 'outrasInformacoesPedagogicas',
    model: 'pedagogicalInfo',
    label: 'Informações pedagógicas',
  },
  {
    table: 'pessoalAdministrativo',
    model: 'administrativeStaff',
    label: 'Pessoal administrativo',
  },
  {
    table: 'mediasMatriculasTurmas',
    model: 'meansEnrollmentsClasses',
    label: 'Médias de matrículas por turma',
  },
  {
    table: 'vinculacaoEscola',
    model: 'schoolLinkage',
    label: 'Vinculação da escola',
  },
  {
    table: 'tbCensoTsQtdAlunos',
    model: 'censusTsQtStudents',
    label: 'Alunos por etapa (base da predição)',
  },
]

// Posição de uma tabela na tela, pela chave da prévia ou do relatório; uma
// chave que a tela não conhece vai ao fim com o próprio nome.
export const tablePosition = (key: string) => {
  const index = CENSUS_TABLES.findIndex(
    ({ table, model }) => table === key || model === key
  )
  return index < 0 ? CENSUS_TABLES.length : index
}

export const formatCount = (value: number) => value.toLocaleString('pt-BR')

// Fuso fixo, o de São Paulo: a data não muda com o relógio da máquina.
const TIME_ZONE = 'America/Sao_Paulo'
const dateFormat = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeZone: TIME_ZONE,
})
const dateTimeFormat = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: TIME_ZONE,
})

export const formatDate = (value: string | Date) =>
  dateFormat.format(new Date(value))

export const formatDateTime = (value: string | Date | null) =>
  value ? dateTimeFormat.format(new Date(value)) : '—'

const STATUS_ICONS = {
  success: { name: 'check-circle', variant: 'positive' },
  warning: { name: 'exclamation-triangle', variant: 'highlight' },
  error: { name: 'times-circle', variant: 'negative' },
  info: { name: 'info-circle', variant: 'primary' },
} as const

export type TAlertStatus = keyof typeof STATUS_ICONS

export const StatusAlert = ({
  status,
  children,
}: {
  status: TAlertStatus
  children: React.ReactNode
}) => (
  <Alert status={status} w="full" maxW="unset" gap={4} py="3xs">
    <Icon
      name={STATUS_ICONS[status].name}
      size="xs"
      variant={STATUS_ICONS[status].variant}
    />
    <Text color="black">{children}</Text>
  </Alert>
)

export const LoadingLine = ({ children }: { children: React.ReactNode }) => (
  <Flex align="center" gap={2}>
    <Spinner size="sm" color="brand.primary.dark_1" label="Carregando" />
    <Typography variant="b-sm">{children}</Typography>
  </Flex>
)
